// imports
import { FC } from 'react';
import { Logout } from '@mui/icons-material';
import { Box, Button, Container, Typography } from '@mui/material';
import { LOG_OUT_BUTTON_TEXT } from 'constants/constant';
import { handleLogout } from 'lib/helper';

//component
import { PlainLayoutContainer } from 'theme/styleComponent';
import { LogoIcon } from 'assets/svgs';

//interfaces, theme, helpers
import { AuthLayoutProps } from 'interfaces';
import { plainLayoutIconBox } from 'styles/commonComponentStyle';

export const PlainLayout: FC<AuthLayoutProps> = ({
  icon,
  title,
  children,
  logoutBtn = true,
  mb = 1,
  maxWidth = '480px',
  paddingX = 'initial',
  subTitle,
}) => {
  return (
    <Box>
      <Container maxWidth={false}>
        <Box sx={plainLayoutIconBox}>
          <LogoIcon width={168} height={62} />

          {logoutBtn && (
            <Button variant="text" color="primary" onClick={handleLogout} endIcon={<Logout />}>
              <Typography variant="subtitle2" component="p">
                {LOG_OUT_BUTTON_TEXT}
              </Typography>
            </Button>
          )}
        </Box>
      </Container>

      <PlainLayoutContainer>
        <Box width="100%" maxWidth={maxWidth} paddingX={paddingX} px={{ xs: 0 }}>
          {icon && (
            <Box textAlign="center" mb={5}>
              {icon}
            </Box>
          )}

          <Box pb={5} pt={5} textAlign="center">
            <Typography variant="h3" mb={mb} textTransform="capitalize">
              {title}
            </Typography>

            <Box>
              {subTitle && (
                <Typography variant="subtitle1" component="p">
                  {subTitle}
                </Typography>
              )}
            </Box>
          </Box>

          {children}
        </Box>
      </PlainLayoutContainer>
    </Box>
  );
};
